const VARIANT_PRIMARY =
  "rounded-md bg-primary50 font-semibold text-N0 transition-all duration-200 ease-out hover:bg-primary70 disabled:pointer-events-none disabled:opacity-60";

const VARIANT_OUTLINE =
  "rounded-md border border-N99/20 bg-transparent font-semibold text-N90 transition-all duration-200 ease-out hover:border-primary50 hover:text-primary50 disabled:pointer-events-none disabled:opacity-60";

const Button = ({ children, custom, onClick, disabled, type, variant }) => {
  const variantClasses =
    variant === "primary"
      ? VARIANT_PRIMARY
      : variant === "outline"
        ? VARIANT_OUTLINE
        : "shadow-md transition-all duration-200 ease-in-out";

  return (
    <button
      type={type ?? "button"}
      disabled={disabled}
      className={`px-4 sm:px-6 capitalize ${variantClasses} ${custom ?? ""}`.trim()}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
